<mat-icon class="help-icon" [matTooltip]="hoverText">help_outline</mat-icon>
